import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { styles } from '../tare-weight-items-styles';

const TareWeightTitle: React.FC<TareWeightTitleProps> = (
  props: TareWeightTitleProps,
): JSX.Element => {
  const classes = styles();
  const { title, itemWeight } = props;
  return (
    <Grid
      container
      direction='column'
      justifyContent='center'
      className={`${classes.tareWeightTitleContainer} fullWidth`}
      data-testid='tare-weight-title'
    >
      <Grid item xs={10} className={`${classes.tareWeightTitleLayout}`}>
        <Grid
          container
          direction='column'
          className={`${classes.tareWeightTitleContainer} fullWidth`}
        >
          <Typography
            className={`${classes.tareWeightTitleHeader} ${classes.tareWeightTitleHeaderLabel}`}
            data-testid='tare-weight-title-text'
          >
            {title}
          </Typography>
          <Grid item xs={1}>
            <Typography className={classes.tareWeightTitleBar} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={2} className={`${classes.tareWeightTitleWeightContainer}`}>
        <Typography
          className={`$ ${classes.tareWeightTitleHeader} ${classes.tareWeightWeightLabel}`}
          data-testid='tare-weight-title-weight'
        >
          {itemWeight}
        </Typography>
      </Grid>
    </Grid>
  );
};
interface TareWeightTitleProps {
  title: string;
  itemWeight: string;
}
export default TareWeightTitle;
